import { Card } from '../components/ui/card';
import { Check } from 'lucide-react';

export const Partner = () => {
  const calendlyUrl = 'https://calendly.com/cristian-verlinestore/30min';

  return (
    <div className="min-h-screen">
      {/* Premium Booking Section */}
      <section className="relative py-20 md:py-28" style={{ background: 'linear-gradient(180deg, #060f1a 0%, #0a192f 40%, #081422 100%)' }}>
        <div className="absolute inset-0 opacity-[0.04]" style={{ backgroundImage: 'radial-gradient(circle at 20% 40%, rgba(127,211,197,0.5) 0%, transparent 50%), radial-gradient(circle at 80% 60%, rgba(127,211,197,0.3) 0%, transparent 50%)' }}></div>
        <div className="relative" style={{ maxWidth: '1320px', margin: '0 auto', padding: '0 24px' }}>
          <div
            style={{
              background: 'linear-gradient(180deg, rgba(25,50,75,0.6) 0%, rgba(15,33,55,0.45) 100%)',
              borderRadius: '22px',
              border: '1px solid rgba(255,255,255,0.08)',
              boxShadow: '0 20px 60px rgba(0,0,0,0.3), 0 0 80px rgba(127,211,197,0.04)',
              padding: '48px',
              position: 'relative',
              overflow: 'hidden',
            }}
            data-testid="booking-container"
          >
            {/* Subtle accent glow */}
            <div style={{ position: 'absolute', top: '-40px', right: '-40px', width: '300px', height: '300px', background: 'radial-gradient(circle, rgba(127,211,197,0.06) 0%, transparent 70%)', pointerEvents: 'none' }}></div>
            <div className="grid md:grid-cols-2 items-start relative" style={{ gap: '48px' }}>
              {/* Left — Text (~52%) */}
              <div>
                <span style={{ fontSize: '12px', letterSpacing: '0.15em', display: 'block', marginBottom: '14px', color: '#5EDBC9', fontWeight: 600 }}>PARTNER WITH VERLINE</span>
                <h1
                  className="text-white font-bold"
                  style={{
                    fontFamily: "'General Sans', sans-serif",
                    fontSize: 'clamp(34px, 4.5vw, 52px)',
                    lineHeight: 1.08,
                    letterSpacing: '-0.025em',
                    marginBottom: '20px',
                  }}
                >
                  Build a Smarter Marketplace Strategy
                </h1>
                <p style={{ fontSize: '18px', lineHeight: 1.6, marginBottom: '24px', maxWidth: '480px', color: '#D1D9E6', textShadow: '0 1px 2px rgba(0,0,0,0.25)' }}>
                  Work directly with our team to identify opportunities, improve control, and scale your brand across key marketplaces.
                </p>

                {/* Bullets */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', marginBottom: '24px' }}>
                  {[
                    'Structured growth plan tailored to your brand',
                    'Marketplace positioning with pricing control',
                    'Clear execution roadmap from day one',
                  ].map((item) => (
                    <div key={item} className="flex items-start" style={{ gap: '11px' }}>
                      <div style={{ width: '26px', height: '26px', borderRadius: '7px', backgroundColor: 'rgba(34,197,150,0.22)', border: '1px solid rgba(255,255,255,0.08)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, marginTop: '2px' }}>
                        <Check style={{ width: '15px', height: '15px', color: '#e0fff6' }} strokeWidth={2.5} />
                      </div>
                      <span className="font-medium" style={{ fontSize: '17px', lineHeight: 1.5, color: '#D8E1EC', textShadow: '0 1px 2px rgba(0,0,0,0.25)' }}>{item}</span>
                    </div>
                  ))}
                </div>

                {/* Supporting paragraph */}
                <p style={{ fontSize: '15.5px', lineHeight: 1.7, maxWidth: '460px', color: '#BFC9D6', textShadow: '0 1px 2px rgba(0,0,0,0.25)' }}>
                  On this call, we'll review your current marketplace presence, identify gaps or risks, and outline a practical path forward. Whether you need distribution, operational support, or full marketplace management — we'll help you understand exactly what's next.
                </p>
              </div>

              {/* Right — Calendly (~48%) */}
              <div>
                <div
                  style={{
                    borderRadius: '16px',
                    overflow: 'hidden',
                    height: '740px',
                    boxShadow: '0 12px 40px rgba(0,0,0,0.3)',
                    position: 'relative',
                  }}
                  data-testid="calendly-container"
                >
                  <div style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.08)', zIndex: 1, pointerEvents: 'none', borderRadius: '16px' }}></div>
                  <iframe
                    src={calendlyUrl}
                    title="Schedule a call with VERLINE"
                    style={{ width: '100%', height: '100%', border: 'none', position: 'relative', zIndex: 0 }}
                    data-testid="calendly-embed"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* What You Can Expect */}
      <section className="relative" style={{ background: 'linear-gradient(to bottom, #060f1a 0%, #0b1a2a 15%, #132840 30%, #1e3a55 45%, #2d506d 58%, #4a7590 70%, #6d96ad 80%, #99bcc9 90%, #d5e2ea 100%)', padding: '72px 0 96px' }}>
        {/* Centered teal glow behind card */}
        <div style={{ position: 'absolute', top: '35%', left: '50%', transform: 'translate(-50%, -50%)', width: '800px', height: '600px', background: 'radial-gradient(circle, rgba(34,197,150,0.06) 0%, transparent 65%)', pointerEvents: 'none', filter: 'blur(50px)' }}></div>
        <div className="relative" style={{ maxWidth: '820px', margin: '0 auto', padding: '0 24px' }}>
          <Card
            className="border"
            style={{
              padding: '48px 44px',
              borderRadius: '22px',
              borderColor: 'rgba(255,255,255,0.12)',
              background: 'rgba(15,33,55,0.65)',
              backdropFilter: 'blur(12px)',
              boxShadow: '0 10px 36px rgba(0,0,0,0.2)',
              transition: 'transform 0.3s ease, box-shadow 0.3s ease',
              cursor: 'default',
            }}
            onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-3px)'; e.currentTarget.style.boxShadow = '0 16px 48px rgba(0,0,0,0.25)'; }}
            onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 10px 36px rgba(0,0,0,0.15)'; }}
            data-testid="what-we-offer-card"
          >
            <h3 className="font-bold text-center text-white" style={{ fontSize: '26px', marginBottom: '14px' }}>What You Can Expect From Us</h3>
            <p className="text-center" style={{ fontSize: '15px', lineHeight: 1.7, maxWidth: '600px', margin: '0 auto 32px', color: '#C7D2E0', textShadow: '0 1px 2px rgba(0,0,0,0.25)' }}>
              We operate with discipline, transparency, and long-term alignment — built to deliver <strong style={{ color: '#ffffff', fontWeight: 600 }}>consistent results</strong>, not short-term wins.
            </p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', marginBottom: '32px' }}>
              {[
                'Controlled and compliant marketplace distribution',
                'Brand-aligned operations with strict pricing integrity',
                'U.S.-based fulfillment and scalable infrastructure',
                'Clear reporting, communication, and full visibility',
              ].map((item) => (
                <div key={item} className="flex items-start" style={{ gap: '12px' }}>
                  <div style={{ width: '26px', height: '26px', borderRadius: '7px', backgroundColor: 'rgba(34,197,150,0.22)', border: '1px solid rgba(255,255,255,0.08)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, marginTop: '1px' }}>
                    <Check style={{ width: '15px', height: '15px', color: '#e0fff6' }} strokeWidth={2.5} />
                  </div>
                  <span style={{ fontSize: '15px', lineHeight: 1.6, color: '#D0D8E5', textShadow: '0 1px 2px rgba(0,0,0,0.25)' }}>{item}</span>
                </div>
              ))}
            </div>
            <div style={{ borderTop: '1px solid rgba(255,255,255,0.12)', paddingTop: '24px' }}>
              <div style={{ background: 'rgba(255,255,255,0.06)', padding: '12px 16px', borderRadius: '11px', borderLeft: '3px solid #4FD1C5' }}>
                <p style={{ fontSize: '15.5px', lineHeight: 1.65, fontWeight: 500, color: 'rgba(255,255,255,0.9)', margin: 0 }}>
                  We don't rely on promises — we execute through <strong style={{ fontWeight: 650 }}>structure, discipline, and results you can verify.</strong>
                </p>
              </div>
            </div>
          </Card>
        </div>
      </section>
    </div>
  );
};
